import { USER_DATA, USER_AREA, RESET_USER_DATA } from "../actions/action-types";

export const userReducer = (
  state = { isUserArea: false, userData: {} },
  action
) => {
  if (action.type === USER_AREA) {
    return {
      ...state,
      isUserArea: action.isUserArea
    };
  }
  if (action.type === USER_DATA) {
    action.userData.fullName = `${action.userData.firstName} ${
      action.userData.lastName
    }`;
    return {
      ...state,
      userData: action.userData
    };
  }
  if (action.type === RESET_USER_DATA) {
    return {
      ...state,
      userData: {}
    };
  }
  return state;
};
